import { Controller, useForm } from 'react-hook-form';
import { Button, Flex, TextAreaField, TextField } from '@aws-amplify/ui-react';
import { useUserQuery } from '../common/useUserQuery';
import { useFactsSheetPutMutation } from './api/useFactsSheetMutation';
import { useFactSheetQuery } from './api/useFactsSheetQuery';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const putFactsSheetRequest = z.object({
  sectionTitle: z
    .string({ message: 'Title is Required' })
    .min(1, { message: 'Title is Required' })
    .max(100, { message: 'Must be 100 or fewer characters long' }),
  sectionDescription: z
    .string({ message: 'Description is Required' })
    .min(1, { message: 'Description is Required' }),
});

const requiredValidations = putFactsSheetRequest.required();

export default function FactSheetEditDetails({ id, onClose }) {
  const { data: userQueryData } = useUserQuery();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: zodResolver(requiredValidations) });
  const { mutate: factsSheetPutMutation } = useFactsSheetPutMutation();
  const { data } = useFactSheetQuery(id, userQueryData?.patientUserId);
  const onSubmit = ({ sectionTitle, sectionDescription }) => {
    factsSheetPutMutation({
      id,
      sectionTitle,
      sectionDescription,
    });
    reset();
    if (onClose) onClose();
  };
  if (data) {
    return (
      <>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Controller
              name="sectionTitle"
              defaultValue={data?.sectionTitle}
              control={control}
              render={({ field }) => (
                <TextField
                  width="100%"
                  label="Section Title"
                  placeholder="Section Title"
                  {...field}
                  errorMessage={errors.sectionTitle?.message}
                  hasError={!!errors.sectionTitle}
                />
              )}
            />
            <Controller
              name="sectionDescription"
              control={control}
              defaultValue={data?.sectionDescription}
              render={({ field }) => (
                <TextAreaField
                  width="100%"
                  label="Section Description"
                  placeholder="Section Description"
                  {...field}
                  errorMessage={errors.sectionDescription?.message}
                  hasError={!!errors.sectionDescription}
                />
              )}
            />
            <Flex direction="row" alignItems="flex-start">
              <Button variation="primary" type="submit">
                Save
              </Button>
              <Button
                variation="primary"
                colorTheme="warning"
                onClick={onClose}
              >
                Close
              </Button>
            </Flex>
          </Flex>
        </form>
      </>
    );
  }
}
